import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';
import Item from '../../components/Form/Item';

const { Option } = Select;

const JobSpecializationForm = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [specializations, setSpecializations] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/job-specialization/list`;
    axios.get(url).then(resp => {
      setSpecializations(resp.data.specializations);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <Item name="Spesialisasi Pekerjaan">
      <Select
        value={formik.values.job_specialization}
        onChange={value => formik.setFieldValue("job_specialization", value)}
        placeholder="Pilih spesialisasi pekerjaan"
        loading={loading}
        showSearch
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
      >
        {specializations.map((item, key) => {
          return <Option value={item.id} key={`job-specialization-${key}`}>{item.name}</Option>
        })}
      </Select>
      <ErrorMessage component="div" name="job_specialization" className="gx-mt-2 gx-text-red" />
    </Item>
  );
}

export default JobSpecializationForm;
